import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationInfusionActionV3 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-infusion-slot-v3',
    templateUrl: './medication-infusion-slot-v3.component.html',
    styleUrl: './medication-infusion-slot-v3.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionSlotComponentV3 implements SheetSlotComponentBase {

	action!: MedicationInfusionActionV3;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationInfusionActionV3 | null) {
		this.action = action as MedicationInfusionActionV3;
		this.value = this.action.dose?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}
